import React from 'react';

// import PropTypes from 'prop-types';
// import { useTranslation } from 'react-i18next';

// import InfoProgressBar from 'components/options/info_progress_bar';
import subscribe from 'HOC/subscribe';
import { crossMarginChannelSelector } from 'selectors';

import styles from './index.module.scss';
import IMAndMMBarComponent from './marginBarsComponent';

const CrossPlaceOrderSection = () => {
  const crossMarginData = crossMarginChannelSelector();
  const {
    im_margins: imMargins,
    mm_margins: mmMargins,
    im_margins_usdt: initialMarginsUSDT,
    mm_margins_usdt: maintenanceMarginsUSDT,
  } = crossMarginData || {};
  const imPercentage = Math.floor(Number(imMargins || 0));
  const mmPercentage = Math.floor(Number(mmMargins || 0));
  // const { openPopup } = props;

  return (
    (<div className={styles.crossContainer} data-palette="CrossPlaceOrderSection">
      <IMAndMMBarComponent
        initialMargin={initialMarginsUSDT || 0}
        maintenanceMargin={maintenanceMarginsUSDT || 0}
        imPercentage={imPercentage}
        mmPercentage={mmPercentage}
        showDetailsLink={false}
      />
    </div>)
  );
};

export default subscribe(CrossPlaceOrderSection);
